import {SkrSplide} from './skr-splide';

class SkrTeaserSplide extends SkrSplide {
    _initSlider() {
        // remove breakpoints if element is inside menu_highlight_trips_teaser__slider & .grid__column.is-medium-8 element
        if (this.closest('.grid__column.is-medium-8') && this.closest('.menu_highlight_trips_teaser__slider')) {
            this.sliderBreakpoints = null;
        }
        super._initSlider();
    }
}

customElements.define('skr-teaser-splide', SkrTeaserSplide);
